import React, { Component } from "react";
import { Accordion, Table } from "semantic-ui-react";
import _ from "lodash";
import getSsn from "../common/Ssn";

class SsnVerificationSection extends Component {
  state = {
    activeIndex: 0,
    rows: [],
    martinRecord: undefined,
    node: undefined,
  };

  componentWillReceiveProps(nextProps) {
    if (
      this.state.martinRecord !== nextProps.martinRecord ||
      this.state.node !== nextProps.node
    ) {
      this.setState({
        martinRecord: nextProps.martinRecord,
        node: nextProps.node,
      });
      this.loadData(nextProps);
    }
  }

  handleClick = () => {
    if (this.state.activeIndex === 0) {
      this.setState({ activeIndex: -1 });
    } else {
      this.setState({ activeIndex: 0 });
    }
  };

  loadData = (props) => {
    const rows = [];
    if (props.martinRecord !== undefined) {
      _.forEach(
        _.get(props.martinRecord, "SSNVerification"),
        (ssnInfo, index) => {
          if (ssnInfo !== undefined) {
            rows.push(
              <Table.Row key={`ssn_row_${index}`}>
                <Table.Cell className="text-bold">Verified Status:</Table.Cell>
                <Table.Cell>{_.get(ssnInfo, "verified[0]._")}</Table.Cell>

                <Table.Cell className="text-bold">Status:</Table.Cell>
                <Table.Cell>{_.get(ssnInfo, "status[0]._")}</Table.Cell>

                <Table.Cell className="text-bold">State Issued:</Table.Cell>
                <Table.Cell>{_.get(ssnInfo, "stateIssued[0]._")}</Table.Cell>
                <Table.Cell className="text-bold">Date Issued:</Table.Cell>
                <Table.Cell>{_.get(ssnInfo, "dateIssued[0]._")}</Table.Cell>
              </Table.Row>
            );
          }
        }
      );
      const recLength = rows.length > 0 ? rows.length : 0;
      if (recLength === 0) {
        rows.push(
          <Table.Row key={`no_recs_row`}>
            <Table.Cell colSpan={100}>No Records found</Table.Cell>
          </Table.Row>
        );
      }
      props.updateItemCountBySection(props.sectionName, recLength);
      this.setState({
        rows,
        activeIndex: 0,
        martinRecord: props.martinRecord,
      });
    } else {
      _.forEach(_.get(props.node, "SSNs[0].SSNRecord"), (ssnInfo, index) => {
        if (ssnInfo !== undefined) {
          rows.push(
            <Table.Row key={`ssn_row_${index}`}>
              <Table.Cell className="text-bold">SSN:</Table.Cell>
              <Table.Cell>
                {getSsn(_.get(ssnInfo, "SSN[0]._"), props)}
              </Table.Cell>

              <Table.Cell className="text-bold">State Issued:</Table.Cell>
              <Table.Cell>{_.get(ssnInfo, "state[0]._")}</Table.Cell>
              <Table.Cell className="text-bold">Date Issued:</Table.Cell>
              <Table.Cell>{_.get(ssnInfo, "years[0]._")}</Table.Cell>
            </Table.Row>
          );
        }
      });
      const recLength = rows.length > 0 ? rows.length : 0;
      if (recLength === 0) {
        rows.push(
          <Table.Row key={`no_recs_row`}>
            <Table.Cell colSpan={100}>No Records found</Table.Cell>
          </Table.Row>
        );
      }
      props.updateItemCountBySection(props.sectionName, recLength);
      this.setState({
        rows,
        activeIndex: 0,
        martinRecord: props.martinRecord,
      });
    }
  };

  render() {
    return (
      <Accordion fluid styled>
        <Accordion.Title
          className="report-section-header"
          active={this.state.activeIndex === 0}
          key={`SsnTitle`}
          onClick={() => this.handleClick()}
        >
          <p>
            SSN Verification
            <span className={"icon-toggle-accordion"}>
              {this.state.activeIndex === 0 ? "-" : "+"}
            </span>
          </p>
        </Accordion.Title>
        <Accordion.Content
          key={`SsnBody`}
          active={this.state.activeIndex === 0}
        >
          <Table>
            <Table.Body>{this.state.rows}</Table.Body>
          </Table>
        </Accordion.Content>
      </Accordion>
    );
  }
}

export default SsnVerificationSection;



// WEBPACK FOOTER //
// ./src/components/reports/SsnVerificationSection.js